import React, { FC, memo } from 'react'

import { useStoreFrontGiftsUrl } from 'components/block/Profile/ProfileMain/hooks/useStoreFrontGiftsUrl'
import { GiftPlaceholder } from 'components/page/ForeignProfile/Gifts/GiftPlaceholder'
import {
  ImagePlaceHolder,
  LeftImage,
  RightImage,
  Wrapper,
  WrapperGiftsEmpty,
} from 'components/page/ForeignProfile/Gifts/Gifts.styled'
import car from 'components/page/ForeignProfile/Gifts/icons/car.svg'
import cat from 'components/page/ForeignProfile/Gifts/icons/cat.svg'
import clock from 'components/page/ForeignProfile/Gifts/icons/clock.svg'
import cocktail from 'components/page/ForeignProfile/Gifts/icons/cocktail.svg'
import crown from 'components/page/ForeignProfile/Gifts/icons/crown.svg'
import flowers_1 from 'components/page/ForeignProfile/Gifts/icons/flowers_1.svg'
import flowers_2 from 'components/page/ForeignProfile/Gifts/icons/flowers_2.svg'
import flowers_3 from 'components/page/ForeignProfile/Gifts/icons/flowers_3.svg'
import flowers_4 from 'components/page/ForeignProfile/Gifts/icons/flowers_4.svg'
import flyHeart from 'components/page/ForeignProfile/Gifts/icons/flyHeart.svg'
import gold from 'components/page/ForeignProfile/Gifts/icons/gold.svg'
import iceCream from 'components/page/ForeignProfile/Gifts/icons/iceCream.svg'
import koala from 'components/page/ForeignProfile/Gifts/icons/koala.svg'
import martini from 'components/page/ForeignProfile/Gifts/icons/martini.svg'
import mask from 'components/page/ForeignProfile/Gifts/icons/mask.svg'
import money from 'components/page/ForeignProfile/Gifts/icons/money.svg'
import star from 'components/page/ForeignProfile/Gifts/icons/star.svg'
import yacht from 'components/page/ForeignProfile/Gifts/icons/yacht.svg'
import { createRandomNumber } from 'functions/createRandomNumber'
import { GQLGender } from 'generated-graphql/graphql'

const icons = [
  car,
  cat,
  clock,
  cocktail,
  crown,
  flowers_1,
  flowers_2,
  flowers_3,
  flowers_4,
  flyHeart,
  gold,
  iceCream,
  koala,
  martini,
  mask,
  money,
  star,
  yacht,
]

export const GiftsIndexEmpty: FC<{
  userId: number
  gender: GQLGender
}> = memo(({ userId, gender }) => {
  const leftImage = icons[createRandomNumber(0, icons.length - 1)]
  const rightImage = icons[createRandomNumber(0, icons.length - 1)]

  const giftsUrl = useStoreFrontGiftsUrl(userId)

  if (leftImage && rightImage) {
    return (
      <WrapperGiftsEmpty>
        <Wrapper
          to={giftsUrl}
          rel="nofollow"
          data-name="gifts-block-empty-action"
        >
          <LeftImage>
            <ImagePlaceHolder src={leftImage} />
          </LeftImage>
          <GiftPlaceholder gender={gender} />
          <RightImage>
            <ImagePlaceHolder src={rightImage} />
          </RightImage>
        </Wrapper>
      </WrapperGiftsEmpty>
    )
  }

  return null
})
